import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_RFID_REQUEST = createActionTypes('FETCH_RFID_REQUEST');
export const GET_RFID_REQUEST = createActionTypes('GET_RFID_REQUEST');
export const UPDATE_RFID_REQUEST = createActionTypes('UPDATE_RFID_REQUEST');
export const DELETE_RFID_REQUEST = createActionTypes('DELETE_RFID_REQUEST');
export const DOWNLOAD_RFID_REQUEST = createActionTypes('DOWNLOAD_RFID_REQUEST');
